import { type TokenUsage, tokenAllowance } from '@toggle/toggle';
import type { WretchError } from 'wretch/resolver';

import { apiFetch } from '~/utils/api-fetch/apiFetch';

const TOKEN_USAGE_ERROR_CODES = [
  'ALLOWANCE_DISABLED',
  'ALLOWANCE_UNKNOWN_USER',
  'ALLOWANCE_UNAVAILABLE',
] as const;

type TokenUsageErrorCode = (typeof TOKEN_USAGE_ERROR_CODES)[number];

const isTokenUsageErrorCode = (
  errorCode: unknown
): errorCode is TokenUsageErrorCode =>
  TOKEN_USAGE_ERROR_CODES.some(code => code === errorCode);

export const getTokenUsage = () =>
  apiFetch<TokenUsage>(tokenAllowance.getUsage.path, {
    schema: tokenAllowance.getUsage.schema,
  });

export const getTokenUsageErrorCode = (
  error: WretchError
): TokenUsageErrorCode | undefined => {
  try {
    const errorBody: unknown = JSON.parse(error.message);

    if (
      typeof errorBody !== 'object' ||
      errorBody === null ||
      !('code' in errorBody) ||
      !isTokenUsageErrorCode(errorBody.code)
    ) {
      return undefined;
    }

    return errorBody.code;
  } catch {
    return undefined;
  }
};
